import { createTheme } from '@mui/material/styles';

/**
 * Main application theme
 * 
 * Centralizes theme configuration for consistent styling across the application.
 * Customize colors, typography, component defaults, etc. in this single location.
 */
export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    // You can add more palette customizations here
    // For example:
    // error: {
    //   main: '#f44336',
    // },
    // warning: {
    //   main: '#ff9800',
    // },
    // info: {
    //   main: '#2196f3',
    // },
    // success: {
    //   main: '#4caf50',
    // },
  },
  // You can add additional theme customizations here:
  // components: {
  //   MuiButton: {
  //     styleOverrides: {
  //       root: {
  //         borderRadius: 8,
  //       },
  //     },
  //   },
  // },
  // typography: {
  //   fontFamily: [
  //     'Roboto',
  //     '"Helvetica Neue"',
  //     'Arial',
  //     'sans-serif'
  //   ].join(','),
  // },
});
